import { ChartBinSize, ChartDefinition, ChartGroupByMode, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';
import { Application } from '@frontend/functionality/types';

import { TRANSACTION_VOLUME_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const NIVALIZ_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.NIVALIZ_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT,
    chartType: ChartRendererType.PIE,
    endpoint: TRANSACTION_VOLUME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.NIVALIZ },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }
    ],
    groupBy: ChartQueryParam.SLOT_DIMENSION,
    groupByMode: ChartGroupByMode.VALUE
};
